import { AfterViewInit, ChangeDetectorRef, Component, ContentChild } from '@angular/core';
import { TextFieldComponent } from '@shared/modules/form-components/text-field/text-field.component';
import { AbstractControl } from '@angular/forms';
import { PhotoUploadComponent } from '@shared/modules/form-components/photo-upload/photo-upload.component';
import { SelectComponent } from '@shared/modules/form-components/select/select.component';
import { DatepickerComponent } from '@shared/modules/form-components/datepicker/datepicker.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FileUploadComponent } from '@shared/modules/form-components/file-upload/file-upload.component';
import { TextAreaComponent } from '@shared/modules/form-components/text-area/text-area.component';
import { TextEditorComponent } from '@shared/modules/form-components/text-editor/text-editor.component';
import { TagsAutocompleteComponent } from '@shared/modules/form-components/tags-autocomplete/tags-autocomplete.component';
import { FormInputComponent } from '@shared/modules/form-components/base/form-input.component';

@UntilDestroy()
@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent implements AfterViewInit {
  @ContentChild(TextFieldComponent, { static: true }) textFieldInput: TextFieldComponent;
  @ContentChild(PhotoUploadComponent, { static: true })
  photoUploadComponent: PhotoUploadComponent;
  @ContentChild(SelectComponent, { static: true }) selectComponent: SelectComponent;
  @ContentChild(DatepickerComponent, { static: true }) datePickerComponent: DatepickerComponent;
  @ContentChild(FileUploadComponent, { static: true }) fileUploadComponent: FileUploadComponent;
  @ContentChild(TextAreaComponent, { static: true }) textAreaComponent: TextAreaComponent;
  @ContentChild(TextEditorComponent, { static: true }) textEditorComponent: TextEditorComponent;
  @ContentChild(TagsAutocompleteComponent, { static: true })
  tagsAutocompleteComponent: TagsAutocompleteComponent;

  control: AbstractControl;
  isHintShown = true;
  hintText: string;
  label: string;
  fieldId: string;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    const component = this.getComponent();
    this.setData(component);

    component?.changeSubject$
      ?.asObservable()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.setData(component);
      });
  }

  private setData(component: FormInputComponent): void {
    if (component) {
      this.control = component.control;
      this.isHintShown = component.isHintShown;
      this.hintText = component.hintText;
      this.label = component.label;
      this.fieldId = component.textFieldId;
      this.cdr.detectChanges();
    }
  }

  private getComponent(): FormInputComponent {
    // eslint-disable-next-line
    const inputTypes: FormInputComponent[] = [
      this.textFieldInput,
      this.photoUploadComponent,
      this.selectComponent,
      this.datePickerComponent,
      this.fileUploadComponent,
      this.textAreaComponent,
      this.textEditorComponent,
      this.tagsAutocompleteComponent,
    ];

    return inputTypes.find((input: FormInputComponent) => !!input?.control) || null;
  }
}
